module.exports = __webpack_public_path__ + "img/user-5.353c856e.svg";